/* Imports */
import React from "react"
import { Font, Flexbox, Alert, Button } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const AlertPage = () => {
    const items = [
        {
            title: "With text",
            content: (
                <>
                    <Alert color="primary">Alert</Alert>
                    <Alert color="secondary">Alert</Alert>
                    <Alert color="success">Alert</Alert>
                    <Alert color="danger">Alert</Alert>
                    <Alert color="warning">Alert</Alert>
                    <Alert color="gray">Alert</Alert>
                    <Alert color="black">Alert</Alert>
                    <Alert color="white">Alert</Alert>
                </>
            ),
            code: '<Alert color="primary">Alert</Alert>\n<Alert color="secondary">Alert</Alert>\n<Alert color="success">Alert</Alert>\n<Alert color="danger">Alert</Alert>\n<Alert color="warning">Alert</Alert>\n<Alert color="gray">Alert</Alert>\n<Alert color="black">Alert</Alert>\n<Alert color="white">Alert</Alert>',
        },
        {
            title: "With buttons",
            content: (
                <Alert color="danger">
                    <Font.P>Alert with buttons</Font.P>

                    <Flexbox align="center" gap="xs">
                        <Button color="danger">Button</Button>
                        <Button buttonStyle="text">Button</Button>
                    </Flexbox>
                </Alert>
            ),
            code: '<Alert color="danger">\n    <Font.P>Alert with buttons</Font.P>\n\n    <Flexbox align="center" gap="xs">\n        <Button color="danger">Button</Button>\n        <Button buttonStyle="text">Button</Button>\n    </Flexbox>\n</Alert>',
        },
    ]

    const propsItems = [
        {
            name: "color",
            type: "String",
            example: "danger",
            possible: commonProps.colorsShort,
            default: "primary",
        },
        {
            name: "modal",
            type: "Boolean",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default AlertPage
